import React, { useState } from "react";
import SEO from "./SEO";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import { toast } from "react-toastify";
import { Link, NavLink, useNavigate } from "react-router-dom";

function Contactus() {
  const navigate = useNavigate();
  const [form, setform] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const formsubmit = (e) => {
    e.preventDefault();
    EnquiryNow();
  };

  const handleChange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  const EnquiryNow = () => {
    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("service", form.service);
    formData.append("message", form.message);

    axios.post("https://moironix.com/mail.php", formData).then(
      (res) => {
        if (res.status === 200) {
          toast.success(res.data.message);
          navigate("/thank-you");
          setform({
            name: "",
            email: "",
            phone: "",
            service: "",
            message: "",
          });
        }
      },
      (error) => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      }
    );
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const accordionItems = [
    {
      id: 1,
      question: "How long does it usually take to develop a mobile app?",
      answer:
        "Developing a mobile app typically takes *3 to 9 months, depending on its complexity, features, and design. Simple apps may take around **3 months, while medium to complex apps with advanced functionalities, integrations, and testing can take **6 to 9 months or more*, including development, testing, and deployment phases.",
    },
    {
      id: 2,
      question: "How much does a new website cost?",
      answer:
        "The cost of a new website varies widely, typically ranging from *₹15,000 to ₹1,50,000* or more. Simple websites cost less, while custom designs, e-commerce features, and advanced functionalities increase the price. Additional costs may include domain registration, hosting, maintenance, and SEO services, depending on the project’s scope and complexity.",
    },
    {
      id: 3,
      question: "Can a mobile app help us reach and attract new customers?",
      answer:
        "Yes, a mobile app can be a powerful tool to reach and attract new customers. With the increasing use of smartphones, people prefer quick, on-the-go access to services and information. A well-designed mobile app not only enhances user experience but also increases brand visibility and engagement.",
    },
    {
      id: 4,
      question:
        "What is digital marketing, and why is it important for my business?",
      answer:
        "Digital marketing refers to all online strategies and techniques used to promote a brand, product, or service through digital channels such as search engines, websites, social media, email, and mobile apps. In simple terms, it’s how your business connects with customers in the digital world.",
    },
    {
      id: 5,
      question:
        "What can I do to improve the SEO of my graphic design website?",
      answer:
        "To improve your website’s search engine ranking, focus on high-quality content, keyword optimization, fast loading speed, mobile-friendliness, and secure HTTPS. Build authoritative backlinks, optimize meta tags and images, and ensure proper internal linking. Regularly update content and use analytics to track performance and adjust strategies accordingly.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <SEO
        title="Contact Us | Moironix Soft Solutions"
        description="Have a Project in Mind? Contact Moironix Soft Solutions for Expert Software Services and Support. We're Just a Message or Call Away — Let's Build Something Great!"
        keywords="Custom Software Development, Software Solutions for Enterprises, Top Software Development Companies in Hyderabad, Best Software Companies in Hyderabad, Best IT companies in Hyderabad, Best Software Company in Hyderabad, Software Company in Hyderabad, Top Software Company in Hyderabad, Top 5 Software Company in Hyderabad, Mobile App Development, Custom Mobile App Development Hyderabad, Hybrid App Development Cost, React Native App Development Services, Flutter App Development for Startups, Mobile App Prototype Development, Mobile App Development Company, Android App Development Services, iOS App Development Services, Mobile App Developers, App Development Agency, Enterprise Mobile App Development, Application Development, Custom Web Application Development, PHP Application Development Services, Java Web Application Development, Net Application Development, SaaS Application Development, Web App Maintenance Services, Application Development Services, Web Application Development, Software Application Development, Custom Application Development, Web App Developers, Enterprise Application Development, Website Design and Development, Responsive Website Design, Ecommerce Website Development Cost, Website Redesign Services, Website Speed Optimization Services, Landing Page Design and Development, Website Design Company, Website Development Services, Web Design and Development, Ecommerce Website Development, Custom Website Design, Digital Marketing, Local Seo Services, Social Media Marketing, Content Marketing Strategy, Email Marketing Automation Services, Pay Per Click Management, Conversion Rate Optimization Services, Digital Marketing Agency, Seo Services, Social Media Marketing Services, Content Marketing Services, PPC Management, Digital Marketing Services, Graphic Design, Logo Design, Infographic Design Services, Brand Identity Design Package, Print Design Services, Ui/Ux Graphic Design, Motion Graphic Design Services, Graphic Design Services, Brand Design, Graphic Designers, Ui/Ux Design, Web Graphic Design"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Contact Us</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">Contact Us</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-main">
        <section className="prt-row bg-layer-equal-height clearfix">
          <div className="container">
            <div className="row g-0">
              <div className="col-lg-6">
                <div className="prt-col-bgcolor-yes bg-base-dark text-base-white col-bg-img-seven prt-col-bgimage-yes prt-bg">
                  <div className="prt-col-wrapper-bg-layer prt-bg-layer bg-base-dark">
                    <div className="prt-col-wrapper-bg-layer-inner bg-base-dark" />
                  </div>
                  <div className="layer-content map-contect-form">
                    <div className="section-title">
                      <div className="title-header">
                        <h2 className="title">
                          Web designing in a powerful way of just not a
                          profession, however
                        </h2>
                      </div>
                    </div>
                    <form
                      onSubmit={(e) => {
                        formsubmit(e);
                      }}
                      method="post"
                      className="query_form wrap-form clearfix mt-25 res-991-mt-0 position-relative"
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <input
                                type="text"
                                name="name"
                                value={form.name}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                required
                                placeholder="Your Name"
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <input
                                required
                                type="email"
                                name="email"
                                placeholder="Your Email"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                value={form.email}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <input
                                required
                                type="text"
                                name="phone"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                maxlength="10"
                                minLength="10"
                                pattern="[0-9]{10}"
                                value={form.phone}
                                placeholder="Your Mobile Number"
                                onKeyPress={(e) => {
                                  // Allow only numeric input
                                  const charCode = e.which
                                    ? e.which
                                    : e.keyCode;
                                  if (charCode < 48 || charCode > 57) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <input
                                required
                                type="text"
                                name="service"
                                placeholder="Enter Service"
                                list="service-options"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                value={form.service}
                              />
                            </span>
                            <datalist id="service-options">
                              <option value="Application Development" />
                              <option value="Web Design & Development" />
                              <option value="Mobile Application Development" />
                              <option value="Digital Marketing" />
                              <option value="Software Maintenance & Support" />
                            </datalist>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <textarea
                                name="message"
                                rows={5}
                                placeholder="Message"
                                type="text"
                                value={form.message}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <div className="mt-25">
                            <button
                              className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant"
                              type="submit"
                            >
                              Submit Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="prt-bg bg-base-grey spacing-8 pb-130">
                  <div className="section-title mb-120">
                    <div className="title-header">
                      <h2 className="section-title-h2">Get in touch</h2>
                    </div>
                    <div className="title-desc">
                      <p>
                        At Moironix Soft Solutions, we are passionate about
                        delivering cutting-edge technology solutions that drive
                        business success. Founded with a vision to empower
                        businesses through digital transformation, we specialize
                        in website development, mobile application development,
                        and custom software solutions.
                      </p>
                    </div>
                  </div>
                  <div className="contact-address-box ">
                    <div className="address-box-info">
                      <h3 className="address-box-heading">Hyderabad</h3>
                      <div className="address-box-text">
                        19/2RT, 1st Floor, Officers Colony, Punjagutta,
                        Hyderabad 500082, India
                      </div>
                    </div>
                    <div className="address-box-map-link">
                      <a
                        href="https://www.google.com/maps/place/Moironix+Soft+Solutions/@17.4300878,78.4485245,17z/data=!4m14!1m7!3m6!1s0xa9bebfd2d40cf5e5:0xe0143cb95cb91015!2sMoironix+Soft+Solutions!8m2!3d17.4300827!4d78.4510994!16s%2Fg%2F11x5y6zzmm!3m5!1s0xa9bebfd2d40cf5e5:0xe0143cb95cb91015!8m2!3d17.4300827!4d78.4510994!16s%2Fg%2F11x5y6zzmm?entry=ttu&g_ep=EgoyMDI1MDMzMC4wIKXMDSoASAFQAw%3D%3D"
                        className="address-box-link"
                      >
                        View Map
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="prt-row  map-accordion-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-12">
                <div className="contentmap">
                  <div className="section-title">
                    <div className="title-header">
                      <h2 className="title">Frequently asked questions</h2>
                    </div>
                    <div className="title-desc">
                      <p>
                        Moironix Soft Solutions Is a Newly Established Private
                        Company Based in Hyderabad, Telangana, India,
                        Specialising in a Range of Digital Services. Moironix 
                        represents someone or something that is unique, stylish, 
                        and strong, standing out with creativity and confidence. 
                        The Company Is Very Young, Having Been Incorporated on April 7,
                        2025. Moironix Soft Solutions Offers Services Including
                        Mobile App Development, Website Design and Development,
                        Digital Marketing, and Graphic Design. Faq Page. Here
                        You'll Find Answers to Common Questions About Our
                        Services, Processes, and How We Can Help Your Business
                        Thrive in the Digital Landscape.
                      </p>
                    </div>
                    <div className="mt-15">
                      <h3 className="contact-heading-h3">Social media</h3>
                      <ul className="social-icons map-links">
                        <li>
                          <a
                            href="https://www.facebook.com/moironixsoftsolutions"
                            rel="noopener"
                            aria-label="facebook"
                            target="_blank"
                          >
                            Facebook
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/company/moironix"
                            rel="noopener"
                            aria-label="twitter"
                            target="_blank"
                          >
                            Linkedin
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/moironixsoft"
                            rel="noopener"
                            aria-label="twitter"
                            target="_blank"
                          >
                            Instagram
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-12">
                <div className="accordion style2 res-991-mt-20">
                  {accordionItems.map((item, index) => (
                    <div
                      key={item.id}
                      className={`toggle prt-toggle_style_classic prt-control-right-true ${
                        activeIndex === index ? "active" : ""
                      }`}
                    >
                      <div
                        className="toggle-title"
                        onClick={() => toggleAccordion(index)}
                      >
                        <span
                          className={activeIndex === index ? "active" : ""}
                          style={{ cursor: "pointer" }}
                        >
                          {`${item.id}. ${item.question}`}
                        </span>
                      </div>
                      {activeIndex === index && (
                        <div className="toggle-content">
                          <p>{item.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="prt-row padding_zero-section overflow-hidden clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 p-0">
                <div id="google_map" className="google_map">
                  <div className="map_container">
                    <div id="map">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.6184760887763!2d78.44852447492029!3d17.43008780157405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa9bebfd2d40cf5e5%3A0xe0143cb95cb91015!2sMoironix%20Soft%20Solutions!5e0!3m2!1sen!2sin!4v1743598589038!5m2!1sen!2sin"
                        style={{ border: 0, width: "100%", height: "600px" }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      />
                    </div>
                  </div>
                  <div className="map-overlay">
                    <div className="prt-map-location">
                      <h3>Find us</h3>
                      <p>
                        19/2RT, 1st Floor, Officers Colony, Punjagutta,
                        Hyderabad 500082, India
                      </p>
                      <ul className="map-list">
                        <li>
                          E-mail :
                          <a
                            href="mailto:contact@company.com"
                            className="prt-maplink"
                          >
                            info@moironix.com ,<br></br>
                            moironix@gmail.com
                          </a>
                        </li>
                        <li>
                          Phone number :
                          <a href="tel:+918328473790" className="prt-maplink">
                            040-45244795 , <br></br>
                            +91 8328 473 790
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="prt-map-location mt-15">
                      <h3>Business hours</h3>
                      <ul className="map-list">
                        <li>
                          Mon-Sat : <span>10am to 7pm</span>
                        </li>
                        <li>
                          Sun : <span>closed</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Contactus;
